const LOCATION_URL =
	process.env.REACT_APP_MODE === "dev"
		? "http://localhost:8300/server/api"
		: window.location.origin + '/server/api';

export default LOCATION_URL;